import styled from "styled-components";

export const Styles = styled.div`
  .ant-select-selection-item {
    font-weight: 400;
  }

  .footer {
    &.group-btn {
      display: flex;
      flex-direction: row;
      gap: 10px;
      margin-top: 30px;

      button {
        min-width: 120px;

        > svg {
          transform: rotate(135deg);
        }
      }
    }
  }
`;
